import { Button, Space } from 'antd';
import React from 'react';
import { ExportAllButton } from './ExportAllButton';

export const ExportFooter = (props: {
  onCancel: () => void;
  disableExport: boolean;
  sections: string[];
  selectedMetrics: string[];
  selectedDimensions: string[];
}) => {
  const { onCancel, disableExport, sections, selectedMetrics, selectedDimensions } = props;
  return (
    <Space style={{ margin: '8px 32px' }} size="middle">
      <ExportAllButton
        disabled={disableExport}
        sections={sections}
        selectedMetrics={selectedMetrics}
        selectedDimensions={selectedDimensions}
        onDone={onCancel}
      />
      <Button onClick={onCancel}>Cancel</Button>
    </Space>
  );
};
